import axios from 'axios';
import Qs from 'qs';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/browser';
import router from '../router';

// 獨立登入品牌 array
import standaloneLoginBrands from '../helpers/standalone-login-brands';

let baseURL = 'https://crm-api.ocard.co';

if (window.location.hostname === 'dev-web.ocard.co' || window.location.hostname === 'localhost') {
  baseURL = 'https://dev-ocard-api.ocard.co/';
} else if (window.location.hostname === 'uat-web.ocard.co') {
  baseURL = 'https://uat-ocard-api.ocard.co/';
}

if (Cookies.get('OCARD_API')) baseURL = Cookies.get('OCARD_API');

const Axios = axios.create({
  baseURL,
  withCredentials: true,
});

Axios.interceptors.request.use(
  (instance) => {
    const config = instance;

    // 從網址取得品牌 id
    const currentBrand = router.app.$route.params.brand;

    // 判斷是否為獨立登入品牌
    const isStandaloneLogin = standaloneLoginBrands.includes(currentBrand);

    let locale = 'zh-Hant';
    const browserLanguage = window.navigator.language || window.navigator.userLanguage;
    if (typeof browserLanguage === 'string') {
      if (browserLanguage.includes('en')) {
        locale = 'en';
      } else if (browserLanguage.includes('vi')) {
        locale = 'vi';
      } else if (browserLanguage.includes('th')) {
        locale = 'th';
      }
    }

    if (typeof Cookies.get('lang') === 'string') {
      locale = Cookies.get('lang');
    }

    if (config.data && !config.data.lang) {
      config.data.lang = locale;
    }

    if (router.app.$route.params.brand && Cookies.get(`s_${router.app.$route.params.brand}`)) {
      config.data.s = Cookies.get(`s_${router.app.$route.params.brand}`);
    }

    config.data = Qs.stringify(instance.data);

    // 如果是獨立登入品牌，utk = utk_${品牌id}
    // 如果不是獨立登入品牌，使用一般 utk
    if (isStandaloneLogin) {
      const utk = Cookies.get(`utk_${currentBrand}`) || null;

      if (utk) {
        config.headers.Authorization = `Bearer ${utk}`;
      }
    } else {
      const utk = Cookies.get('utk') || null;

      if (utk) {
        config.headers.Authorization = `Bearer ${utk}`;
      }
    }

    return config;
  },
  (error) => {
    Sentry.captureException(error);
    return Promise.reject(error);
  },
);

Axios.interceptors.response.use(
  response => response,
  (error) => {
    Sentry.captureException(error);
    return Promise.reject(error);
  },
);

export default Axios;
